<template>
    <span class="report__table-title bold">{{ valueDate }}</span>
    <EmptyScreen v-if="isObjEmpty(dataSummary)" text="no data" />
    <template v-else>
        <div class="report__table-item">
            <span class="report__table-column-label bold uppercase">
                {{ getTranslatedText('Summary') }}
            </span>
        </div>
        <!-- <template v-for="(v, i) in tableList" :key="i">
            <template v-if="(v.key === 'float_adjustments' && dateFrom != dateTo) || v.key !== 'float_adjustments'">
                <div class="report__table-item">
                    <span class="report__table-column-label">
                        {{ getTranslatedText(v.label) }}
                    </span>
                    <span :class="['report__table-column-value', { highlight: v?.highlight }]" v-if="!isStrEmpty(v.key)">
                        {{ dataSource.currency || $store.state.config.setup.currency }}
                        <template v-if="v.key === 'true_balance'">
                            {{ renderTrueBalance() }}
                        </template>
                        <template v-else>
                            {{ formatPrice(dataSource[v.key]) }}
                        </template>
                    </span>
                </div>
            </template>
        </template> -->
        <template v-for="(dItem, i) in displays" :key="i">
            <div class="report__table-item">
                <span class="report__table-column-label">
                    {{ getTranslatedText(dItem.name) }}
                </span>
                <span :class="['report__table-column-value', { highlight: filedSummaryHighlight.includes(dItem.field) }]">
                    {{ $store.state.config.setup.currency }}
                    {{ formatPrice(dataSummary?.[dItem.field] || 0) }}
                </span>
            </div>
        </template>
    </template>
    <div class="report__table-item-data-report" v-if="dataReport.length > 0">
        <template v-for="(x, i) in dataReport" :key="i">
            <div
                class="report__table-item-data-report-item"
                :class="{ odd: i % 2 === 0, even: i % 2 !== 0 }"
                v-if="x.product_type && x.product_type !== ''"
            >
                <div class="report__table-item">
                    <span class="report__table-column-label bold uppercase">{{ getTranslatedText(x.product_type) }}</span>
                </div>
                <div class="report__table-item">
                    <span class="report__table-column-label">
                        {{ getTranslatedText('stakes') }}
                    </span>
                    <span class="report__table-column-value highlight">
                        {{ x.currency || $store.state.config.setup.currency }}
                        {{ formatPrice(x.wagers) }}
                    </span>
                </div>
                <div class="report__table-item">
                    <span class="report__table-column-label">
                        {{ getTranslatedText('payouts') }}
                    </span>
                    <span class="report__table-column-value">
                        {{ x.currency || $store.state.config.setup.currency }}
                        {{ formatPrice(x.payouts) }}
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

import EmptyScreen from '@/components/common/emptyScreen/empty.vue';

import { formatDateUTC } from '@/utils/utils';

const filedSummaryHighlight = ['cash_deposits', 'float_adjustments', 'true_balance'];

export default {
    mixins: [languageMixins, utilsMixin],
    components: { EmptyScreen },
    props: {
        // dataSource: {
        //     type: Object,
        //     default: () => null,
        // },
        displays: {
            type: Array,
            default: () => [],
        },
        dataSummary: {
            type: Object,
            default: () => null,
        },
        dataReport: {
            type: Array,
            default: () => null,
        },
        cashier: {
            type: Object,
            default: () => null,
        },
        isFinal: {
            type: Boolean,
            default: true,
        },
        dateTo: {
            type: String,
            default: '',
        },
        dateFrom: {
            type: String,
            default: '',
        },
        valueDate: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            filedSummaryHighlight,
            // tableList: [
            //     {
            //         label: 'cash deposits',
            //         key: 'cash_deposits',
            //         highlight: true,
            //     },
            //     {
            //         label: 'cancellations',
            //         key: 'refunded_cancelations',
            //         highlight: false,
            //     },
            //     {
            //         label: 'payouts',
            //         key: 'payouts',
            //         highlight: false,
            //     },
            //     {
            //         label: 'float adjustments',
            //         key: 'float_adjustments',
            //         highlight: true,
            //     },
            //     {
            //         label: 'true balance',
            //         key: 'true_balance',
            //         highlight: true,
            //     },
            // ],
            tableListReport: [
                {
                    label: '',
                    key: 'product_type',
                },
                {
                    label: 'wagers',
                    key: 'wagers',
                    highlight: true,
                },
                {
                    label: 'payouts',
                    key: 'payouts',
                    highlight: false,
                },
            ],
        };
    },
    // methods: {
    //     renderTrueBalance() {
    //         let today = this.renderDate(new Date());
    //         let trueBalance =
    //             this.dateFrom === this.dateTo && this.dateFrom === today ? this.dataSource.true_balance : this.dataSource.cash_difference;
    //         return this.formatPrice(trueBalance);
    //     },

    //     renderDate(date) {
    //         const dateFormat = formatDateUTC(date, 2);

    //         let valueDate = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`;

    //         return valueDate;
    //     },
    // },
};
</script>
